import { Space, Tag } from 'antd'

import { queryBankPageApi } from '@eastcoal/api/finance/bank/queryBankPage'

import { ButtonGroup } from '@eastcoal/common/components/ButtonGroup'
import { RemoteTable } from '@eastcoal/common/components/RemoteTable'
import { useUrlParams } from '@eastcoal/common/hooks/useUrlParams'
import { formatBankCard } from '@eastcoal/common/utils/bankCard'
import { mapProValueEnum } from '@eastcoal/common/utils/enums'

import { BankTypeTextMap } from '@eastcoal/shared/enums/BankType'

import { useMemberBankListStore } from '../Store/hooks/useStore'

import { MemberBankCreateButton } from './components/CreateButton'
import { MemeberBankDeleteButton } from './components/DeleteButton'
import { MemberBankEditButton } from './components/EditButton'
import { MemberBankSetDefaultButton } from './components/SetDefaultButton'
import { MemberBankListProps } from './interface'

const columns: MemberBankListProps['columns'] = [
  {
    title: '银行账号',
    dataIndex: 'bankAccount',
    align: 'center',
    render(value) {
      return formatBankCard(value)
    }
  },
  {
    title: '开户银行',
    dataIndex: 'bankName',
    align: 'center'
  },
  {
    title: '开户支行',
    dataIndex: 'bankBranch',
    align: 'center'
  },
  {
    title: '账号类别',
    dataIndex: 'bankType',
    align: 'center',
    valueEnum: mapProValueEnum(BankTypeTextMap)
  },
  {
    title: '收款人/收款单位',
    dataIndex: 'receiver',
    align: 'center',
    render(_, { receiver, defaultBank }) {
      return (
        <Space size='small'>
          {receiver}
          {defaultBank && (
            <Tag color='error' variant='filled'>
              默
            </Tag>
          )}
        </Space>
      )
    }
  },
  {
    dataIndex: 'action',
    title: '操作',
    align: 'center',
    width: 120,
    render: (_, record) => {
      return (
        <ButtonGroup>
          <MemberBankSetDefaultButton record={record} />
          <MemberBankEditButton record={record} />
          <MemeberBankDeleteButton record={record} />
        </ButtonGroup>
      )
    }
  }
]

const toolbar: MemberBankListProps['toolbar'] = {
  search: ['银行账号'],
  extraActions: {
    left: [<MemberBankCreateButton key='memberAccountCreateButton' />]
  }
}

export const MemberBankList = () => {
  const tableRef = useMemberBankListStore(state => state.tableRef)
  const { memberId } = useUrlParams()

  return (
    <RemoteTable
      ref={tableRef}
      api={queryBankPageApi}
      columns={columns}
      readyRequest={!!memberId}
      requestParams={{ memberId }}
      rowKey='id'
      toolbar={toolbar}
    />
  )
}
